export const ssoQueryKeys = {
  config: ["sso", "config"] as const,
  spMetadata: ["sso", "sp-metadata"] as const,
  preCheck: ["sso", "precheck"] as const,
};
